export default __webpack_public_path__ + "static/media/Icon-angle-right.430d83f5.svg";